import { type HTMLProps, type ReactNode, isValidElement } from "react";
import { classNames } from "../../../../utility/jsx";
import styles from "./style.module.scss";

type MsgProps = {
  /**
   * Any string, an array of strings, or a React node to display in the message box.
   */
  msg: string | string[] | ReactNode;
} & HTMLProps<HTMLDivElement>;

function MsgBox(props: MsgProps) {
  const { className, msg, ...forward } = props;
  if (isValidElement(msg)) {
    // ReactNode should directly be rendered.
    return (
      <div {...forward} className={classNames(styles.message, className)}>
        {msg}
      </div>
    );
  }

  if (typeof msg === "string") {
    return (
      <div {...forward} className={classNames(styles.message, className)}>
        <span>{props.msg}</span>
      </div>
    );
  }
  // A string array is converted to a list.
  const msgJsx = (
    <ul className={styles["message-list"]}>
      {(msg as string[]).map((msg, i) => (
        <li key={msg}>{msg}</li>
      ))}
    </ul>
  );
  return (
    <div {...forward} className={classNames(styles.message, className)}>
      {msgJsx}
    </div>
  );
}

export function ErrorMsgBox(props: MsgProps) {
  const { className, ...forward } = props;
  return <MsgBox {...forward} className={classNames(styles.error, className)} />;
}

export function WarningMsgBox(props: MsgProps) {
  const { className, ...forward } = props;
  return <MsgBox {...forward} className={classNames(styles.warning, className)} />;
}

export function SuccessMsgBox(props: MsgProps) {
  const { className, ...forward } = props;
  return <MsgBox {...forward} className={classNames(styles.success, className)} />;
}
